exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-tags-input{max-width:100%!important}.ti-tag{color:#555!important;border:1px solid #cbd5dd;background-color:#fff!important;font-size:14px!important;flex-direction:row-reverse}.ti-tag .ti-actions{margin-left:0!important;margin-right:2px;font-size:1em!important}.ti-tag .ti-actions .ti-icon-close{font-weight:900!important}.ti-autocomplete .ti-selected-item{background-color:#337ab7;color:#fff;text-decoration-line:underline}.vue-tags-input .ti-deletion-mark{color:#555!important;background-color:#999!important;font-size:14px}.business-services-tags .vue-tags-input .ti-input{border:none}.line-height-39{height:39px}", ""]);

// exports
